<h5>Tarefa para criação de dados de contratos no RCC</h5>

<div class="container">
  <div ngbAccordion>
    <div ngbAccordionItem [collapsed]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title">
          Inclusão/Consulta de contrato (ENDI)
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div class="col-md-3">
                <label for="idSistema1">Sistema: *</label>
                <select
                  required
                  type="text"
                  id="idSistema1"
                  class="form-select"
                  bnMask="INTEIRO"
                  [(ngModel)]="idSistema1"
                >
                  <option>15</option>
                  <option>84</option>
                  <option>89</option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="numeroContrato1">Contrato: *</label>
                <div class="input-group">
                  <input
                    *ngIf="!(numeroContratoLength() == 11); else bloqueiaInput"
                    required
                    id="main_search_input"
                    (keyup)="calculaDvContrato()"
                    type="text"
                    id="numeroContrato1"
                    class="form-control"
                    bnMask="CONTRATO"
                    maxlength="14"
                    [(ngModel)]="numeroContrato1"
                  />
                  <ng-template #bloqueiaInput>
                    <input
                      required
                      [disabled]="numeroContratoLength() == 11"
                      id="main_search_input"
                      (keyup)="calculaDvContrato()"
                      type="text"
                      id="numeroContrato1"
                      class="form-control"
                      bnMask="CONTRATO"
                      maxlength="14"
                      [(ngModel)]="numeroContrato1"
                    />
                  </ng-template>
                  <span class="input-group-btn">
                    <button
                      [disabled]="!numeroContratoLength()"
                      (click)="limparContrato()"
                      ngbTooltip="Limpar campo"
                      class="btn btn-light border"
                      type="button"
                    >
                      <i class="fas fa-eraser"></i>
                    </button>
                    <button
                      [disabled]="!(numeroContratoLength() == 11)"
                      ngbTooltip="Copiar Contrato"
                      [cdkCopyToClipboard]="numeroContrato1"
                      class="btn btn-light border"
                      type="button"
                    >
                      <i class="fa fa-clipboard"></i>
                    </button>
                  </span>
                  <span class="erro" *ngIf="10 > numeroContratoLength()"
                    >Preencha os 10 primeiros dígitos.</span
                  >
                </div>
              </div>

              <div class="col-md-3">
                <label for="cnpjAgenteFinanceiro">CNPJ do Agente Financeiro: </label>
                <input
                  [disabled]="idSistema1 == null || numeroContrato1 == null"
                  type="text"
                  id="cnpjAgenteFinanceiro"
                  class="form-control"
                  bnMask="CNPJ"
                  [(ngModel)]="cnpjAgenteFinanceiro"
                />
              </div>

              <div class="col-md-3">
                <label for="controleMCF">Contrato controlado por:</label>
                <select
                  type="text"
                  id="controleMCF"
                  class="form-select"
                  [(ngModel)]="controleMCF"
                  (ngModelChange)="controleMCF = $event === 'true'"
                >
                  <option value="false">SCC</option>
                  <option value="true">MCF</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema1 == null || numeroContrato1 == null"
                  type="button"
                  class="btn btn-primary no-margin"
                  (click)="consultarContrato()"
                >
                  Consultar
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="
                    idSistema1 == null ||
                    numeroContrato1 == null ||
                    cnpjAgenteFinanceiro == null
                  "
                  type="button"
                  class="btn btn-success no-margin"
                  (click)="incluirContrato()"
                >
                  Criar
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema1 == null || numeroContrato1 == null"
                  type="button"
                  class="btn btn-danger no-margin"
                  (click)="excluirContrato()"
                >
                  Excluir
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema1 == null || numeroContrato1 == null"
                  type="button"
                  class="btn btn-success no-margin"
                  (click)="simularProCdd()"
                >
                  Simular Pro-CDD
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema1 == null || numeroContrato1 == null"
                  type="button"
                  class="btn btn-danger no-margin"
                  (click)="excluirSimulacaoProCdd()"
                >
                  Excluir simulacao Pro-CDD
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title2">
          Inclusão/Consulta de saldo de principal (SALD)
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div class="col-md-3">
                <label for="idSistema2">Sistema: *</label>
                <select
                  type="text"
                  id="idSistema2"
                  class="form-select"
                  bnMask="INTEIRO"
                  [(ngModel)]="idSistema2"
                >
                  <option>15</option>
                  <option>84</option>
                  <option>89</option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="numeroContrato2">Contrato: * </label>
                <input
                  type="text"
                  class="form-control"
                  bnMask="CONTRATO"
                  [required]="true"
                  [(ngModel)]="numeroContrato2"
                />
                <span class="erro" *ngIf="11 > numeroContratoLength()"
                  >O contrato deve possuir 11 dígitos.</span
                >
              </div>

              <div class="col-md-3">
                <label for="valorEmReais1">Valor em reais: </label>
                <input
                  [disabled]="idSistema2 == null || numeroContrato2 == null"
                  type="text"
                  id="valorEmReais1"
                  class="form-control"
                  bnMask="MOEDA"
                  [(ngModel)]="valorEmReais1"
                />
              </div>

              <div class="col-md-3">
                <label>Data competência:</label>
                <bn-datepicker
                  [disabled]="idSistema2 == null || numeroContrato2 == null"
                  name="dataMovimento1"
                  idInput="dataMovimento1"
                  ngDefaultControl
                  [(ngModel)]="dataMovimento1"
                >
                </bn-datepicker>
              </div>
            </div>

            <div class="row">
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema2 == null || numeroContrato2 == null"
                  type="button"
                  class="btn btn-primary no-margin"
                  (click)="consultarSaldoDePrincipal()"
                >
                  Consultar
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="
                    idSistema2 == null ||
                    numeroContrato2 == nul ||
                    dataMovimento1 == null
                  "
                  type="button"
                  class="btn btn-success no-margin"
                  (click)="incluirSaldoDePrincipal()"
                >
                  Criar
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema2 == null || numeroContrato2 == null"
                  type="button"
                  class="btn btn-danger no-margin"
                  (click)="excluirSaldoDePrincipal()"
                >
                  Excluir
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title3">
          Inclusão/Consulta de movimento (MOVI)
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div class="col-md-3">
                <label for="idSistema3">Sistema: * </label>
                <select
                  type="text"
                  id="idSistema3"
                  class="form-select"
                  bnMask="INTEIRO"
                  [(ngModel)]="idSistema3"
                  (change)="filtrarEventos($event.target.value)"
                >
                  <option [value]="15">15</option>
                  <option [value]="84">84</option>
                  <option [value]="89">89</option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="numeroContrato3">Contrato: * </label>
                <input
                  type="text"
                  class="form-control"
                  bnMask="CONTRATO"
                  [required]="true"
                  [(ngModel)]="numeroContrato3"
                />
                <span class="erro" *ngIf="11 > numeroContrato3"
                  >O contrato deve possuir 11 dígitos.</span
                >
              </div>

              <div class="col-md-3">
                <label for="eventoScc">Evento:</label>
                <select
                  [disabled]="idSistema3 == null || numeroContrato3 == null"
                  type="text"
                  id="eventoScc"
                  class="form-select"
                  [(ngModel)]="ideEventoScc"
                >
                  <option [ngValue]="undefined"></option>
                  <option
                    [ngValue]="evento.codigo"
                    *ngFor="let evento of eventosFiltrados"
                  >
                    {{ evento.codigo }} - {{ evento.nome }}
                  </option>
                </select>
              </div>

              <div class="col-md-3">
                <label for="valorEmReais2">Valor em reais: </label>
                <input
                  [disabled]="idSistema3 == null || numeroContrato3 == null"
                  type="text"
                  id="valorEmReais2"
                  class="form-control"
                  bnMask="MOEDA"
                  [(ngModel)]="valorEmReais2"
                />
              </div>
              <div class="col-md-3">
                <label>Data:</label>
                <bn-datepicker
                  [disabled]="idSistema3 == null || numeroContrato3 == null"
                  name="dataMovimento2"
                  idInput="dataMovimento2"
                  ngDefaultControl
                  [(ngModel)]="dataMovimento2"
                >
                </bn-datepicker>
              </div>
            </div>

            <div class="row">
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema3 == null || numeroContrato3 == null"
                  type="button"
                  class="btn btn-primary no-margin"
                  (click)="consultarMovimento()"
                >
                  Consultar
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="
                    idSistema3 == null ||
                    numeroContrato3 == null ||
                    ideEventoScc == null ||
                    valorEmReais2 == null ||
                    dataMovimento2 == null
                  "
                  type="button"
                  class="btn btn-success no-margin"
                  (click)="incluirMovimento()"
                >
                  Criar
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  [disabled]="idSistema3 == null || numeroContrato3 == null"
                  type="button"
                  class="btn btn-danger no-margin"
                  (click)="excluirMovimento()"
                >
                  Excluir
                </button>
              </div>
            </div>
            <div
              class="table-responsive"
              *ngIf="movisConsultados && movisConsultados?.length > 0"
            >
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="Evento">Evento</th>
                    <th scope="col">Valor R$</th>
                    <th scope="col">Dt. comp.</th>
                    <th scope="col">Dt. pagto.</th>
                    <th scope="col">Dt. reg.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let movi of movisConsultados">
                    <td>{{ movi.ideEventoScc }}</td>
                    <td>{{ movi.valorEmReais | bnMask: "MOEDA" }}</td>
                    <td>{{ movi.dataCompetencia | date: "dd/MM/yyyy" }}</td>
                    <td>{{ movi.dataPagamento | date: "dd/MM/yyyy" }}</td>
                    <td>{{ movi.dataRegistro | date: "dd/MM/yyyy" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title4">
          Inclusão de movimentos em lote (MOVI)
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row" class="col-md-5">
              <label for="arquivo">Arquivo CSV:</label>
              <div id="customFile">
                <input
                  type="file"
                  accept=".csv"
                  class="form-control"
                  id="arquivo"
                  onclick="this.value=null;"
                  (change)="onFileChange($event)"
                  #fileInput
                  [disabled]="loteEnviado"
                />
              </div>
            </div>
            <div class="row">
              <div class="submit col-auto">
                <button
                  [disabled]="0 >= loteMovisCsv?.length"
                  type="button"
                  class="btn btn-success no-margin"
                  (click)="incluirLoteMovimentos()"
                >
                  Enviar
                </button>
              </div>
              <div class="submit col-auto">
                <button
                  type="button"
                  class="btn btn-info no-margin"
                  (click)="baixarCsvExemplo()"
                >
                  <i class="fa fa-file"></i> Exportar CSV de exemplo
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="title3">Execução carga RCC para o FG2 (F-RCC)</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div class="col-md-4 alert alert-warning">
                Esta tarefa copia dados de contratos e seus movimentos (ENDI e MOVI) do RCC para a base de dados do FG2 (F-RCC).
              </div>
              <div class="submit col-auto">
                <button type="button" class="btn btn-success no-margin" (click)="carregarRccFg2()">Executar carga</button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
